/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  addEncoderSizePrefix,
  addDecoderSizePrefix,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Report entry (placeholder) */
export type ReportEntry = {
  /** Entry data */
  data: string;
};

export type ReportEntryArgs = {
  /** Entry data */
  data: string;
};

export function getReportEntryEncoder(): Encoder<ReportEntryArgs> {
  return getStructEncoder([
    ["data", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getReportEntryDecoder(): Decoder<ReportEntry> {
  return getStructDecoder([
    ["data", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getReportEntryCodec(): Codec<ReportEntryArgs, ReportEntry> {
  return combineCodec(getReportEntryEncoder(), getReportEntryDecoder());
}
